module.exports = "/images/vendor/flag-icon-css/flags/4x3/fo.svg?037e466d03f81cd46e76b58aa73fe492";